import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider, signInWithPopup } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

// Configuración de Firebase
const firebaseConfig = {
  apiKey: "AIzaSyB9xaWw6ycSg37VHZ5LdRzKdNvtwO2qEGE",
  authDomain: "smartgroup-c30a2.firebaseapp.com",
  projectId: "smartgroup-c30a2",
  storageBucket: "smartgroup-c30a2.appspot.com",
  messagingSenderId: "336217655431",
  appId: "1:336217655431:web:cf00d418075170ed151022"
};

// Inicializa Firebase
const app = initializeApp(firebaseConfig);

// Inicializa Auth y Firestore usando módulos
export const auth = getAuth(app);
export const db = getFirestore(app);

// Proveedor de Google
const provider = new GoogleAuthProvider();
provider.setCustomParameters({ prompt: 'select_account' });

// Función de inicio de sesión con Google
export const signInWithGoogle = () => signInWithPopup(auth, provider);

export default app;